module.exports = __webpack_public_path__ + "static/media/sale-banner2.dd867140.jpg";